export const CopyIcon = ({ width = 11, height = 14, fill = 'currentColor' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.5 0H2.125C2.05625 0 2 0.05625 2 0.125V1C2 1.06875 2.05625 1.125 2.125 1.125H9.875V11.875C9.875 11.9438 9.93125 12 10 12H10.875C10.9438 12 11 11.9438 11 11.875V0.5C11 0.223437 10.7766 0 10.5 0ZM8.5 2H0.5C0.223437 2 0 2.22344 0 2.5V10.7922C0 10.925 0.0531249 11.0516 0.146875 11.1453L2.85469 13.8531C2.88906 13.8875 2.92813 13.9156 2.97031 13.9391V13.9688H3.03594C3.09062 13.9891 3.14844 14 3.20781 14H8.5C8.77656 14 9 13.7766 9 13.5V2.5C9 2.22344 8.77656 2 8.5 2ZM2.96875 12.3781L1.62344 11.0312H2.96875V12.3781ZM7.875 12.875H3.96875V10.6562C3.96875 10.3109 3.68906 10.0312 3.34375 10.0312H1.125V3.125H7.875V12.875Z" fill="#007EF5" />
    </svg>
  );
};

export const AlarmIcon = ({ width = 11, height = 14, fill = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={"18px"} viewBox="0 -960 960 960" width="18px" fill={fill}><path d="M339.5-108.5q-65.5-28.5-114-77t-77-114Q120-365 120-440t28.5-140.5q28.5-65.5 77-114t114-77Q405-800 480-800t140.5 28.5q65.5 28.5 114 77t77 114Q840-515 840-440t-28.5 140.5q-28.5 65.5-77 114t-114 77Q555-80 480-80t-140.5-28.5ZM480-440Zm112 168 56-56-128-128v-184h-80v216l152 152ZM224-866l56 56-170 170-56-56 170-170Zm512 0 170 170-56 56-170-170 56-56ZM480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720q-117 0-198.5 81.5T200-440q0 117 81.5 198.5T480-160Z" /></svg>
  );
};


export const HelpIcon = ({ width = 11, height = 14, fill = 'currentColor' }) => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg"
      height="20px"
      viewBox="0 -960 960 960"
      width="20px"
      fill="currentColor">
      <path d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Z" /></svg>

  );
};

export const SearchIcon = ({ width = 11, height = 14, fill = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 20" stroke="currentColor">
      <circle cx="11" cy="11" r="7" stroke-width="2.5"></circle>
      <line x1="16.65" y1="16.65" x2="21" y2="21" stroke-width="2.5"></line>
    </svg>
  );
};

export const AddIcon = ({ width = 11, height = 14, fill = 'currentColor' }) => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="-100 -960 960 800" width="16px" fill="currentColor">
      <path d="M440-280h80v-160h160v-80H520v-160h-80v160H280v80h160v160Zm40 200q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  );
};



export const SettingsIcon = ({ width = 11, height = 14, fill = 'currentColor' }) => {
  return (

    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      viewBox="0 -960 960 960"
      width="20px" fill="currentColor">
      <path d="m403-96-22-114q-23-9-44.5-21T296-259l-110 37-77-133 87-76q-2-12-3-24t-1-25q0-13 1-25t3-24l-87-76 77-133 110 37q19-16 40.5-28t44.5-21l22-114h154l22 114q23 9 44.5 21t40.5 28l110-37 77 133-87 76q2 12 3 24t1 25q0 13-1 25t-3 24l87 76-77 133-110-37q-19 16-40.5 28T579-210L557-96H403Zm77-240q60 0 102-42t42-102q0-60-42-102t-102-42q-60 0-102 42t-42 102q0 60 42 102t102 42Z" /></svg>

  );
};


export const SortIcon = ({ width = 8, height = 6, fill = 'currentColor' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 6"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 6L0.535898 6.52533e-07L7.4641 4.68497e-08L4 6Z" fill="currentColor" />
    </svg>
  );
};

export const InfoIcon = ({ width = 16, height = 19, fill = 'currentColor' }) => {

  return (
    <svg
      width={width}
      height={height}
      viewBox="-1 -2 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.56208 9.51423V10.0742H8.62608L8.68208 9.68223C8.72874 9.38357 8.83608 9.0849 9.00408 8.78623C9.17208 8.48757 9.47541 8.13757 9.91408 7.73623C10.3994 7.29757 10.7354 6.89157 10.9221 6.51823C11.1181 6.1449 11.2161 5.74357 11.2161 5.31423C11.2161 4.84757 11.0901 4.44157 10.8381 4.09623C10.5954 3.7509 10.2501 3.48023 9.80208 3.28423C9.36341 3.08823 8.85008 2.99023 8.26208 2.99023C7.66474 2.99023 7.07208 3.09757 6.48408 3.31223C5.90541 3.5269 5.42008 3.81157 5.02808 4.16623L5.61608 5.51023C6.39074 4.83823 7.23541 4.50223 8.15008 4.50223C8.56074 4.50223 8.87808 4.5909 9.10208 4.76823C9.32608 4.94557 9.43808 5.18823 9.43808 5.49623C9.43808 5.75757 9.37741 6.0049 9.25608 6.23823C9.14408 6.47157 8.93874 6.75157 8.64008 7.07823C8.24808 7.5169 7.96808 7.9229 7.80008 8.29623C7.64141 8.66957 7.56208 9.07557 7.56208 9.51423ZM7.11408 11.0542V13.0002H9.07408V11.0542H7.11408Z" fill="white" />
    </svg>
  )
}

export const CheckboxInactive = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    <svg
      width={width}
      height={height}
      className="checkbox-icon"
      viewBox="0 0 10 10"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="9" height="9" fill-opacity="0" stroke="currentColor" />
    </svg>
  )
}

export const CheckboxActive = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    <svg
      width={width}
      height={height}
      className="checkbox-icon"
      viewBox="0 0 10 10"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M2 0C0.895431 0 0 0.89543 0 2V8C0 9.10457 0.89543 10 2 10H8C9.10457 10 10 9.10457 10 8V2C10 0.895431 9.10457 0 8 0H2ZM4.86448 7.71926L8.37215 3.05645C8.51388 2.8659 8.5375 2.6081 8.44302 2.38393C8.34853 2.17097 8.12414 2.02525 7.87612 2.00284C7.6281 1.98042 7.38008 2.0925 7.23836 2.28305L4.21491 6.30696L2.69137 4.86105C2.51421 4.69292 2.25439 4.62566 2.01818 4.69292C1.77016 4.76017 1.59301 4.93951 1.52214 5.16368C1.46309 5.38785 1.52214 5.63444 1.6993 5.80257L3.80154 7.80893C3.93146 7.93222 4.10861 7.99947 4.29758 7.99947H4.35663C4.55741 7.97706 4.74637 7.87618 4.86448 7.71926Z" fill="currentColor" />
    </svg>
  )
}

export const CalendarIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="2" width="8" height="7" rx="1" stroke={fill} strokeWidth="0.8" />
      <line x1="1" y1="4" x2="9" y2="4" stroke={fill} strokeWidth="0.8" />
      <rect x="3" y="0.5" width="1" height="2" rx="0.3" fill={fill} />
      <rect x="6" y="0.5" width="1" height="2" rx="0.3" fill={fill} />
    </svg>
  )
}

export const ColumnsIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="3" width="4" height="14" rx="1" fill="currentColor" />
      <rect x="8" y="3" width="4" height="14" rx="1" fill="currentColor" />
      <rect x="14" y="3" width="4" height="14" rx="1" fill="currentColor" />
    </svg>
  )
}

export const PinIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="currentColor">
      <path d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Z" />
    </svg>

  )
}




export const MessageIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    
<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 760" width="20px" fill="currentColor"><path d="M480-680q17 0 28.5-11.5T520-720q0-17-11.5-28.5T480-760q-17 0-28.5 11.5T440-720q0 17 11.5 28.5T480-680Zm-40 320h80v-240h-80v240ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Z"/></svg>
  )
}


export const PlusIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="currentColor">
      <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/>
    </svg>
  )
}

export const CheckIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -860 760 600" width="16px" fill="currentColor">
      <path d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z" />
    </svg>
  )
}




export const EditIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="currentColor"><path d="M144-144v-153l498-498q11-11 24-16t27-5q14 0 27 5t24 16l51 51q11 11 16 24t5 27q0 14-5 27t-16 24L297-144H144Zm549-498 51-51-51-51-51 51 51 51Z" /></svg>
  )
}

export const ViewIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="currentColor"><path d="M480-312q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm0-72q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 192q-142.6 0-259.8-78.5Q103-349 48-480q55-131 172.2-209.5Q337.4-768 480-768q142.6 0 259.8 78.5Q857-611 912-480q-55 131-172.2 209.5Q622.6-192 480-192Z" /></svg>
  )
}


export const TrashIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="currentColor"><path d="m400-325 80-80 80 80 51-51-80-80 80-80-51-51-80 80-80-80-51 51 80 80-80 80 51 51Zm-88 181q-30 0-51-21t-21-51v-480h-48v-72h192v-48h192v48h192v72h-48v480q0 30-21 51t-51 21H312Z" /></svg>
  )
}








export const LockIcon = ({ width = 10, height = 10, fill = 'currentColor' }) => {
  return (<svg fill='currentColor' xmlns="http://www.w3.org/2000/svg" height="17px" viewBox="0 -1080 990 960" width="20px"><path d="M263.72-96Q234-96 213-117.15T192-168v-384q0-29.7 21.15-50.85Q234.3-624 264-624h24v-96q0-79.68 56.23-135.84 56.22-56.16 136-56.16Q560-912 616-855.84q56 56.16 56 135.84v96h24q29.7 0 50.85 21.15Q768-581.7 768-552v384q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72Zm.28-72h432v-384H264v384Zm216.21-120Q510-288 531-309.21t21-51Q552-390 530.79-411t-51-21Q450-432 429-410.79t-21 51Q408-330 429.21-309t51 21ZM360-624h240v-96q0-50-35-85t-85-35q-50 0-85 35t-35 85v96Zm-96 456v-384 384Z" /></svg>)
}




